
import { useMemo } from "react";
import { ChartDataPoint, PuttingResult } from "@/types/puttingResults";

export const useChartData = (
  chartDataByTest: Record<string, ChartDataPoint[]>,
  testTypes: string[],
  selectedLevel: string | null,
  trainingResults: PuttingResult[]
) => {
  // Filtrer les types de tests en fonction du niveau sélectionné
  const filteredTestTypes = useMemo(() => {
    if (!selectedLevel) {
      return testTypes;
    }
    
    // Définir un ensemble des tests du niveau sélectionné
    const testsInLevel = new Set(
      trainingResults
        .filter(r => String(r.test_level) === selectedLevel)
        .map(r => r.test_name || r.test_id || 'Standard')
    );
    
    // Ne retenir que les types de tests présents dans cet ensemble
    return testTypes.filter(testType => testsInLevel.has(testType));
  }, [testTypes, selectedLevel, trainingResults]);
  
  // Filtrer chartDataByTest pour ne garder que les tests du niveau sélectionné
  const filteredChartData = useMemo(() => {
    if (!selectedLevel) {
      return chartDataByTest;
    }
    
    const filteredData: Record<string, ChartDataPoint[]> = {};
    
    filteredTestTypes.forEach(testType => {
      if (chartDataByTest[testType]) {
        // Pour chaque type de test, ne garder que les données du niveau sélectionné
        filteredData[testType] = chartDataByTest[testType].filter(
          dataPoint => dataPoint.level === selectedLevel
        );
      }
    });
    
    return filteredData;
  }, [chartDataByTest, selectedLevel, filteredTestTypes]);
  
  return {
    filteredTestTypes,
    filteredChartData
  };
};
